export default {
	location: 'Location ',
	south: 'South',
	north: 'North',
	category: {
		fish: 'Fish',
		bugs: 'Bug',
		furnitures: 'Furniture',
		villagers: 'Villager',
		flowers: 'Flower',
		deepsea: 'Sea Creature'
	},
	month: '',
	monthPre: 'Month ',
	fishShadow: 'Shadow ',
	fishShadows: {
		Smallest: 'Smallest',
		Small: 'Small',
		Medium: 'Medium',
		Large: 'Large',
		Larger: 'Larger',
		Largest: 'Largest',
	},
	fishLocation: 'Location ',
	fishLocations : {
		river: 'River',
		sea: 'Sea',
		pond: 'Pond',
		clifftop: 'Clifftop',
		pier: 'Pier',
		riverMouth: 'Mouth',
	},
	placeholder: ' Search Here',
	rank:{
		HightoLow : 'Price: High to Low',
		LowtoHigh: 'Price: Low to High',
	},
	card: {
		random: "whole day",
		common: "whole year",
		price: "Price",
		time: 'Time',
		month: 'Month',
		fishShadow: 'Shadow Size',
		fishLocation: 'Location',
		diy: 'Need DIY',
		species: 'Species',
		personality: 'Personality',
		birthday: 'Birthday',
		deepSeaShadow: 'Shadow'

	}
}